
import { ConfigOption, FormlyFieldConfig } from '@ngx-formly/core';
import { VimboFieldMatchValidator } from './VimboFieldMatchValidator';

export function fieldMatchValidationMessage(error: any, field: FormlyFieldConfig) {
  return `keine Übereinstimmung`;
}

export const SIMPLE_JSON_ENTRY_FORMLY_VALIDATORS: ConfigOption['validators'] = [
  { name: "fieldMatch", validation: VimboFieldMatchValidator },
]

export const SIMPLE_JSON_ENTRY_FORMLY_VALIDATION_MESSAGES: ConfigOption['validationMessages'] = [
  { name: 'fieldMatch', message: fieldMatchValidationMessage },
]
